
import { extendTheme } from "@chakra-ui/react"

// Add our fonts
import '@fontsource-variable/source-code-pro';

const theme = extendTheme({
    colors: {
        white: {
            100: "#FFFFFF", // True white
            200: "#F9FAFB", // Header text
            300: "#D1D5DB", // Description text
            400: "#5E5E60", // Tags
        },
        black: {
            100: "#000000", // True black
            200: "#030712", // Primary background
            300: "#111827", // Secondary background
            400: "#1F2937", // Experience items background
            500: "#374151", // Work items primary background, tags
        },
        green: {
            100: "#69EA5E", // Primary green
        },
        pink: {
            100: "#DF058D", // Primary pink
        },
        blue: {
            100: "#5E73EA", // Primary blue
            200: "#03A9F4", // Zenith blue
            300: "#5EEAD4", // Tag text blue, Testimonials background, Progress Bar background
            400: "#122B39", // Tag background
            500: "#50A9E2", // Testimonial Background
        },
        orange: {
            100: "#FF6B2B", // Primary orange
            200: "#D6C08A", // Speak Easy orange
        },
        purple: {
            100: "#9874D7", // LSU purple
            200: "#BC60FB", // Testimonial background
        },
        red: {
            100: "#F56A6B", // D&D Red
            200: "#FF0000", // YouTube red
        },
        yellow: {
            100: "#FDD023"  // DMAE yellow
        },
    },
})

export default theme